module.exports = __webpack_public_path__ + "img/banner4.adce9823.png";